goog.provide("shadow.js.shim.module$$mui$x_data_grid_premium");
goog.provide("module$shadow_js_shim_module$$mui$x_data_grid_premium");
shadow.js.shim.module$$mui$x_data_grid_premium = shadow.js.nativeProvides["@mui/x-data-grid-premium"] = shadow$bridge("@mui/x-data-grid-premium");
module$shadow_js_shim_module$$mui$x_data_grid_premium.default = shadow.js.shim.module$$mui$x_data_grid_premium;
